import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';

import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const QualityStockFollowUpView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [value, setValue] = useState({});
  const [valuee, setValuee] = useState([]);
    const [permission, setPermission] = useState({});
      let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(458)); 
console.log(permission);

    axios
      .get(`/quality-stock-follow-ups/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setValue(response.data.data.stock);
        setValuee(response.data.data.items);
        

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);


 
  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }


 
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Stock Situation View </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-stock-situations">Quality Stock Situation</Link>
                    </li>
                    <li className="breadcrumb-item active">View</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
              {permission && permission.list === 1 && (
                <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Quality Stock Situation Infornamtion</h4>
                  <table className="table table-bordered">
                    <tr>
                      <th className="p-3">Location </th>
                      <td className="p-3">
                        {value.location_detail ? value.location_detail.title : ""}
                      </td>
                    </tr>
                    <tr>
                      <th  className="p-3">Date</th>
                      <td className="p-3">{value.date}</td>
                    </tr>
                
                  </table>

                  <h2>items#</h2>

                      <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="">Operation</th>
                              <th className="">Delivery Note Number</th>
                              <th className="">Consumable</th>
                              <th  className="">Quantity</th>
                              <th  className=""> Note</th>
                              <th  className="">Delivery Note</th>
                          </tr>
                        </thead>
                        {valuee &&
                          valuee.map((item, indx) => (
                            <tr  key={item.operation || indx}>
                              <td className="p-3">{item.operation}</td>
                              <td className="p-3">{item.delivery_note_number}</td>
                              <td className="p-3"> {item.consumable_product ? item.consumable_product.consumable_name : ""}</td>
                              <td className="p-3">{item.quantity}</td>
                              <td className="p-3">{item.note}</td>
                           
                              <td>
                              {item.delivery_note && item.delivery_note !=null  && (
                                <a
                                className="btn btn-link"
                                href={viewFile(item.delivery_note) }
                                target="_blank"
                                rel="noreferrer"
                                download
                                >
                                Download
                                </a>
                              )}
                               
                              </td>
                            </tr>
                          ))}

                      </table>

                </div>
              </div>
              )}
                
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpView;
